import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useLang, CHOICE_KEY } from "@/context/LanguageContext";
import { IS_BOT } from "@/lib/isBot";

const COPY = {
  it: { q: "Questa pagina è disponibile in Italiano", cta: "Passa all'Italiano" },
  en: { q: "This page is available in English", cta: "Switch to English" },
  de: { q: "Diese Seite ist auf Deutsch verfügbar", cta: "Auf Deutsch wechseln" },
  es: { q: "Esta página está disponible en Español", cta: "Cambiar a Español" },
  fr: { q: "Cette page est disponible en Français", cta: "Passer au Français" },
};
const DISMISS_KEY = "vornx-lang-suggest-dismissed";

// Never auto-redirects: only suggests the browser language once.
export const LangSuggest = () => {
  const { lang, setLang } = useLang();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (IS_BOT || localStorage.getItem(CHOICE_KEY) || sessionStorage.getItem(DISMISS_KEY)) return setTarget(null);
    const nav = (navigator.language || "").slice(0, 2).toLowerCase();
    setTarget(COPY[nav] && nav !== lang ? nav : null);
  }, [lang]);

  if (!target) return null;
  const close = () => { sessionStorage.setItem(DISMISS_KEY, "1"); setTarget(null); };

  return (
    <div data-testid="lang-suggest" className="fixed left-1/2 top-24 z-40 flex w-[calc(100%-2rem)] max-w-md -translate-x-1/2 items-center justify-between gap-4 border border-gold/30 bg-ink/90 px-5 py-3 text-xs text-white/75 backdrop-blur-xl sm:w-auto sm:max-w-none">
      <span className="min-w-0">{COPY[target].q}</span>
      <button data-testid="lang-suggest-switch" onClick={() => setLang(target)} className="shrink-0 whitespace-nowrap uppercase tracking-widest text-gold transition-colors hover:text-white">
        {COPY[target].cta}
      </button>
      <button data-testid="lang-suggest-close" aria-label="Close" onClick={close} className="text-white/40 transition-colors hover:text-white">
        <X size={14} />
      </button>
    </div>
  );
};
